import { useEffect } from 'react'
import { lockScroll, unlockScroll } from '@/utils/scrollLock'

export const useModalScrollLock = (locked: boolean) => {
  useEffect(() => {
    // Only release a lock we took: an unconditional unlock would release locks owned by others (e.g. FloatingProfileModal)
    if (!locked) return
    lockScroll()
    return () => unlockScroll()
  }, [locked])
}
